import { fetchDeletePromisedData, updateRequest, dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";

export const getDropdowns = async () => {
  const dropdown = await Promise.all([
    dropdownMapping(
      endpoint.academic_career.getAllActive,
      "academicCareerDispValue",
      "id"
    ),
    dropdownMapping(
      endpoint.groupCode.getAllActive,
      "groupCodeDispValue",
      "id"
    ),
    dropdownMapping(
      endpoint.companyCode.getAllActive,
      "companyCodeDispValue",
      "id"
    ),
    dropdownMapping(
      endpoint.item_type_setup.getAllActive,
      "itemTypeId",
      "id",
      "description"
    ),
    dropdownMapping(
      endpoint.academic_group.getAllActive,
      "academicGroupDispValue",
      "academicGroupDispValue",
    ),
    dropdownMapping(
      endpoint.businessArea.getAllActiveV2,
      "businessAreaDispValue",
      "businessAreaDispValue",
    ),

  ]);
  return {
    academicCareer: dropdown[0],
    businessGroup: dropdown[1],
    companyCode: dropdown[2],
    itemTypes: dropdown[3],
    academicGroup: dropdown[4],
    activeBusinessAreas: dropdown[5],
    mode: [{ label: 'OFFLINE', value: 'OFFLINE' }, { label: 'ONLINE', value: 'ONLINE' }]
  };
}

export const getCreateReqBody = (rowData) => {
  const { minimumAdmissionPercentage, minimumReadmitPercentage, minimumRegistrationPercentage, tribyteAccess, websiteIntegration, businessArea, isFeeComponent } = rowData;
  return updateRequest({
    companyCode: rowData?.companyCode?.label ?? rowData?.companyCode,
    businessGroup: rowData?.businessGroup?.label ?? rowData?.businessGroup,
    status: rowData?.status,
    academicCareer: rowData?.academicCareer?.label ?? rowData?.academicCareer,
    itemType: rowData?.itemType?.label ?? rowData?.itemType,
    businessArea: businessArea?.label || businessArea || "ALL",
    description: rowData?.itemType?.description ?? rowData?.description,
    mode: rowData?.mode?.label ?? rowData?.mode,
    id: rowData?.id,
    discDays: rowData?.discDays,
    matrItemType: rowData?.matrItemType?.label ?? rowData?.matrItemType,
    minimumAdmissionPercentage,
    minimumReadmitPercentage,
    minimumRegistrationPercentage,
    isFeeComponent,
    tribyteAndWebsiteIntegrationList: tribyteAccess && tribyteAccess.map(item => (
      {
        tribyteAccess: item?.label ?? item,
        websiteIntegration: websiteIntegration
      }
    ))

  });
};
export const newRow = {
  businessGroup: "",
  companyCode: "",
  academicCareer: "",
  itemType: "",
  mode: "",
  businessArea: "",
  status: "ACTIVE",
  websiteIntegration: true,
  isFeeComponent: true,
  tribyteAccess: [
    { label: 'SOM', value: 'SOM' },
    { label: 'SOE', value: 'SOE' },
    { label: 'SOF', value: 'SOF' },
  ]
};

export const formatTribyteAccess = (val = []) => {
  if (!Array.isArray(val)) return "";

  return val.map(item => item?.label || "").join(", ");
};

export const EMPTY_FILTER_FORM = {
  businessAreas: [],
  academicCareers: [],
  status: '',
  appliedFilterCount: 0
}

export const getFilterFormFields = (dropdownData, filterForm) => {
  const { activeBusinessAreas, academicCareer } = dropdownData;

  return [
    {
      label: 'Business area',
      type: 'select',
      items: activeBusinessAreas,
      formKey: 'businessAreas',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select branch",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Academic career',
      type: 'select',
      items: academicCareer,
      formKey: 'academicCareers',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select Academic Career",
      disbabled: false,
      isShowCount: true
    },
  ]
}

export const deleteConfig = async (id) => {
  let resp = await fetchDeletePromisedData(`${endpoint?.sdChargePayment?.delete}/${id}`)
  if (resp?.code === 200) {
    return true;
  } else {
    return false;
  }
}